export const config = {
  ui: {
    urls: {
      notFound() {
        return '/not-found'
      },
    },
  },
}
